<template>
<div class="reg-info-container">
  <div class="ccon1">
    <div class="title_2">
      <h1 class="main-title">Finish setting up your account</h1>
      <div class="title-underline"></div>
      <p class="subtitle">Complete your profile to get started</p>
    </div>

    <div class="gender-container">
      <div class="section_2">
        <div class="section-title_2">
          <span class="section-icon">👤</span>
          Please select your gender
        </div>
        <div class="ow">
          <button
            class="gender-button"
            :class="{ selected: selectedGender === 'male' }"
            @click="selectGender('male')"
          >
            <span class="gender-icon">👨</span>
            <span class="gender-text">MALE</span>
          </button>
          <button
            class="gender-button"
            :class="{ selected: selectedGender === 'female' }"
            @click="selectGender('female')"
          >
            <span class="gender-icon">👩</span>
            <span class="gender-text">FEMALE</span>
          </button>
        </div>
      </div>
    </div>

    <div class="slider-container">
      <div class="slider-header">
        <span class="section-icon">📚</span>
        <label for="academic-year">What is your academic year?</label>
      </div>
      <div class="slider-wrapper">
        <input 
          type="range" 
          id="academic-year" 
          min="0" 
          max="5" 
          v-model="selectedYear" 
          @input="updateValue"
          class="custom-slider"
        />
        <div class="slider-labels">
          <div
            v-for="(label, index) in labels"
            :key="index"
            class="label-item"
            :class="{ active: Number(selectedYear) === index }"
            role="button"
            tabindex="0"
            @click="selectYear(index)"
            @keypress.enter="selectYear(index)"
          >
            {{ label }}
          </div>
        </div>
      </div>
    </div>

    <div class="section_2">
      <div class="section-title_2">
        <span class="section-icon">🖼️</span>
        Please select your Avatar!
      </div>
      <div class="ow">
        <div 
          class="options_2" 
          v-for="item in Avatars" 
          :key="item.id"
          :class="{ selected: selectedAvatar === item.imgUrl }"
          @click="selectAvatar(item.imgUrl)"
        >
          <img :src="item.imgUrl" class="img_u" alt="Avatar">
        </div>
      </div>
    </div>

    <button class="finish-button_2" @click="preFinish()">
      <span class="button-text">Complete Setup</span>
      <span class="button-icon">→</span>
    </button>
  </div>
</div>
</template>
<script>

import axios from 'axios';
import Swal from 'sweetalert2';
export default{
    data(){
        return{
            selectedYear: '',
             labels: ['Freshmen', 'Sophomore', 'Junior', 'Senior', 'Master', 'PhD'],
            selectedGender: null,
            userName:'',
            Houses:[],
            Avatars:[],
            selectedUniversity: '' // 用于存储选中的图片名称
            ,selectedAvatar:''
            
        }
    },
    methods:{
        updateValue() {
      this.selectedYear = Number(this.selectedYear);
    },
    selectYear(index) {
      this.selectedYear = index;
    },
        selectGender(gender) {
      this.selectedGender = gender;
    },
        fetchHouses() {
        // 假设后端接口的 URL 是 http://localhost:3000/api/houses
        axios.get('/api/info/university')
            .then(response => {
            console.log(response)
            this.Houses = response.data.data; // 将获取的数据赋值给 houses
            console.log(this.Houses)
            })
            .catch(error => {
            console.error('Error fetching data:', error);
            this.houses = []; // 如果出错，清空数据
            });
    },
    fetchAvatars() {
        // 假设后端接口的 URL 是 http://localhost:3000/api/houses
        axios.get('/api/info/avatars')
            .then(response => {
            console.log(response)
            this.Avatars = response.data.data; // 将获取的数据赋值给 houses
            console.log(this.Avatars)
            })
            .catch(error => {
            console.error('Error fetching data:', error);
            this.Avatars = []; // 如果出错，清空数据
            });
    },
    selectUniversity(name) {
      this.selectedUniversity = name; // 更新选中的图片名称
    },
    selectAvatar(imgUrl){
        this.selectedAvatar=imgUrl;
    },
    preFinish(){
      // Enhanced validation with better error messages
      const errors = [];

      const yearNum = Number(this.selectedYear);
      if (this.selectedYear === '' || this.selectedYear === null || Number.isNaN(yearNum)) {
        errors.push('Please select your academic year');
      }

      if (!this.selectedGender) {
        errors.push('Please select your gender');
      }

      if (!this.selectedAvatar) {
        errors.push('Please select your avatar');
      }

      if (errors.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: '<span style="color: #2c3e50; font-size: 1.5rem; font-weight: 600;">Please Complete Required Fields</span>',
          html: `
            <div style="text-align: left; margin: 20px 0;">
              <div style="background: #fff3cd; border: 1px solid #ffeaa7; border-radius: 8px; padding: 15px; margin-bottom: 15px;">
                <div style="color: #856404; font-weight: 600; margin-bottom: 10px;">Required Information:</div>
                <div style="color: #856404;">
                  ${errors.map(error => `<div style="margin: 8px 0; padding-left: 20px; position: relative;">
                    <span style="position: absolute; left: 0; color: #e74c3c;">•</span>
                    ${error}
                  </div>`).join('')}
                </div>
              </div>
            </div>
          `,
          confirmButtonText: 'Got it!',
          confirmButtonColor: '#3bc2ff',
          cancelButtonColor: '#64748b',
          background: '#ffffff'
        });
        return;
      }

      this.finish(this);
    },
    finish(obj){
          axios.post('/api/info/update', {
            "gender":this.selectedGender,
            "grade": Number(this.selectedYear),
        "avatar": this.selectedAvatar
        })
        .then(function (response) {
          console.log(response);
          obj.ToMainPage();
          localStorage.setItem('gender',obj.selectedGender);
          localStorage.setItem('grade', String(obj.selectedYear));
          localStorage.setItem('avatar', obj.selectedAvatar);
          location.reload(true);
          
        })
        .catch(function (error) {
          alert(error);
        });
    },
    ToMainPage(){
        if (this.$route.path !== '/MainPage') {
            this.$router.push('/MainPage');
        } else {
            console.log('Already on MainPage page');
        }
    },
    },
    mounted(){
        this.userName = localStorage.getItem('name');
        this.selectedAvatar = localStorage.getItem('avatar');
        this.selectedGender = localStorage.getItem('gender');
        this.selectedYear = localStorage.getItem('grade');
        this.fetchHouses();
        this.fetchAvatars();

    }
    

}

</script>


<style>
/* Global Styles */
* {
  box-sizing: border-box;
}

/* Main Container */
.reg-info-container {
  min-height: 100vh;
  background: #eaf2ff;
  padding: 24px 20px 48px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.ccon1 {
  background: white;
  border-radius: 20px;
  padding: 24px 40px 40px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
  margin: 0 auto;
  transition: all 0.3s ease;
}

.ccon1:hover {
  transform: translateY(-5px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

/* Title Section */
.title_2 {
  text-align: center;
  margin-bottom: 40px;
}

.main-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 15px 0;
  letter-spacing: 1px;
}

.title-underline {
  width: 80px;
  height: 4px;
  background: #409EFF;
  margin: 0 auto 15px;
  border-radius: 2px;
}

.subtitle {
  color: #7f8c8d;
  font-size: 1.1rem;
  margin: 0;
  line-height: 1.6;
}

/* Section Styling */
.section_2 {
  margin-bottom: 40px;
}

.section-title_2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  gap: 12px;
  letter-spacing: 0.5px;
}

.section-icon {
  font-size: 1.8rem;
  color: #409EFF;
}

/* Gender Container */
.gender-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.ow {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  align-items: center;
}

/* Gender Buttons */
.gender-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 20px 30px;
  border: 2px solid #e3f2fd;
  border-radius: 15px;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.gender-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(64, 158, 255, 0.2);
  border-color: #409EFF;
}

.gender-button.selected {
  border-color: #409EFF;
  background: #409EFF;
  color: white;
  box-shadow: 0 10px 25px rgba(64, 158, 255, 0.3);
}

.gender-icon {
  font-size: 2rem;
}

.gender-text {
  font-weight: 600;
  font-size: 1rem;
  letter-spacing: 1px;
}

/* University Options */
.options_2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 15px;
  border: 2px solid #e3f2fd;
  border-radius: 15px;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.options_2:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(64, 158, 255, 0.2);
  border-color: #409EFF;
}

.options_2.selected {
  border-color: #409EFF;
  background: #409EFF;
  box-shadow: 0 10px 25px rgba(64, 158, 255, 0.3);
}

.img_u {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.options_2.selected .img_u {
  transform: scale(1.1);
}

.p_u {
  font-weight: 600;
  color: #2c3e50;
  text-align: center;
  margin: 0;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
}

.options_2.selected .p_u {
  color: white;
}

/* Slider Container */
.slider-container {
  margin: 40px 0;
  padding: 30px;
  background: #f8f9ff;
  border-radius: 20px;
  border: 1px solid #e3f2fd;
}

.slider-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 25px;
}

.slider-header label {
  font-size: 1.3rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.slider-wrapper {
  position: relative;
}

.custom-slider {
  width: 100%;
  height: 8px;
  background: #e3f2fd;
  outline: none;
  border-radius: 4px;
  -webkit-appearance: none;
  appearance: none;
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.custom-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  background: #409EFF;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 5px 15px rgba(64, 158, 255, 0.3);
  transition: all 0.3s ease;
}

.custom-slider::-webkit-slider-thumb:hover {
  transform: scale(1.2);
  box-shadow: 0 8px 20px rgba(64, 158, 255, 0.4);
}

.custom-slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  background: #409EFF;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  box-shadow: 0 5px 15px rgba(64, 158, 255, 0.3);
}

.slider-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}

.label-item {
  flex: 1;
  text-align: center;
  font-size: 0.9rem;
  color: #7f8c8d;
  font-weight: 500;
  transition: all 0.3s ease;
  cursor: pointer;
  padding: 5px;
  border-radius: 8px;
}

.label-item.active {
  color: #409EFF;
  font-weight: 600;
  background: rgba(64, 158, 255, 0.1);
}

.label-item:hover {
  color: #409EFF;
  background: rgba(64, 158, 255, 0.05);
}

/* Finish Button */
.finish-button_2 {
  background: #409EFF;
  color: white;
  border: none;
  border-radius: 50px;
  padding: 15px 40px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 40px auto 0;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(64, 158, 255, 0.3);
}

.finish-button_2::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s ease;
}

.finish-button_2:hover::before {
  left: 100%;
}

.finish-button_2:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 35px rgba(64, 158, 255, 0.4);
  background: #aaf2ff;
}

.finish-button_2:active {
  transform: translateY(-1px);
}

.button-text {
  position: relative;
  z-index: 1;
  letter-spacing: 1px;
}

.button-icon {
  position: relative;
  z-index: 1;
  font-size: 1.2rem;
  transition: transform 0.3s ease;
}

.finish-button_2:hover .button-icon {
  transform: translateX(5px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .ccon1 {
    padding: 24px 20px;
    margin: 0 10px 10px;
  }
  
  .main-title {
    font-size: 2rem;
  }
  
  .section-title_2 {
    font-size: 1.3rem;
  }
  
  .ow {
    gap: 15px;
  }
  
  .gender-button,
  .options_2 {
    min-width: 100px;
    padding: 15px 20px;
  }
  
  .img_u {
    width: 60px;
    height: 60px;
  }
  
  .slider-container {
    padding: 20px;
  }
  
  .slider-labels {
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .label-item {
    font-size: 0.8rem;
    padding: 3px;
  }
}

@media (max-width: 480px) {
  .reg-info-container {
    padding: 16px 12px 48px;
  }
  
  .main-title {
    font-size: 1.8rem;
  }
  
  .ow {
    flex-direction: column;
    align-items: center;
  }
  
  .gender-button,
  .options_2 {
    width: 100%;
    max-width: 200px;
  }
  
  .finish-button_2 {
    padding: 12px 30px;
    font-size: 1rem;
  }
}

/* Focus styles for accessibility */
.gender-button:focus-visible,
.options_2:focus-visible,
.finish-button_2:focus-visible,
.custom-slider:focus-visible {
  outline: 2px solid #409EFF;
  outline-offset: 2px;
}

/* Smooth scrolling */
html {
  scroll-behavior: smooth;
}

/* Loading states */
.finish-button_2.is-loading {
  opacity: 0.7;
  pointer-events: none;
}

/* Custom scrollbar */
.ccon1::-webkit-scrollbar {
  width: 8px;
}

.ccon1::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.ccon1::-webkit-scrollbar-thumb {
  background: #409EFF;
  border-radius: 4px;
}

.ccon1::-webkit-scrollbar-thumb:hover {
  background: #aaf2ff;
}
</style>